function headerAdjustments(){
  
  	var additionalHeight = 92;
  
  if ($(window).width() < 769) {
    if($('header.promo-bar').length > 0){
      $('.top-bar-mobile').css('top',$('header.promo-bar').height()+'px');
      $('#menu.panel').css('padding-top',$('header.promo-bar').height() + additionalHeight + 'px');
      $('#shopify-section-header').css('padding-top', $('header.promo-bar').height() +'px');
    }else{
      $('.top-bar-mobile').css('top',0);
      $('#menu.panel').css('padding-top', additionalHeight +'px');
      $('#shopify-section-header').css('padding-top', 0);
    }
  }
}
$(document).ready(function(){
  $('.search-icon-trigger').click(function(){
  	$(this).parents('.top-bar-mobile').next().slideToggle();
  });
  $('.close-icon-trigger').click(function(){
  	$('.mobile-menu-overlay').trigger('click');
  });
  $('.back-nav a').click(function(){
  	$(this).parent().parent().prev().trigger('click');
  });
  headerAdjustments();
  
  $('.easyslider-contents .easyslider-item .easyslider-header').on('click', function() {
    $(this).toggleClass('active').siblings('.easyslider-content').slideToggle();
  });
})
window.onresize = function() {
  headerAdjustments();
}